import { DogReproductionType, GenderType, PregnantPeriodType } from '@granlupo/api-client/generated/content/zeus'
import { z } from 'zod'

export const Castrated = z.object({
	type: z.literal(DogReproductionType.castrated),
})

export const BreastfeedingCategory = z.object({
	id: z.string().uuid(),
})

export const Breastfeeding = z.object({
	type: z.literal(DogReproductionType.breastfeeding),
	breastfeedingCategory: BreastfeedingCategory,
	breastfeedingPuppyCount: z.number().int().min(1),
})

export const Pregnant = z.object({
	type: z.literal(DogReproductionType.pregnant),
	pregnancy: z.nativeEnum(PregnantPeriodType),
})

export const Healthy = z.object({
	type: z.literal('healthy'),
})

export const DogInfoStep1 = z.object({
	fedProduct: z
		.union([z.literal('undisclosed'), z.string().uuid()])
		.optional()
		.nullable(),
	breed: z.string().uuid(),
	age: z.string().uuid(),
	gender: z.nativeEnum(GenderType),
	activity: z.string().uuid(),
})
export type DogInfoStep1 = z.infer<typeof DogInfoStep1>

export const DogInfoReproduction = z.union([Castrated, Breastfeeding, Pregnant])

export const DogInfoStep2 = z.object({
	bodyType: z.string().uuid(),
	weight: z.number().min(1),
	idealWeight: z.number().min(1).nullable(),
	reproduction: DogInfoReproduction.nullable(),
	illnesses: z.array(z.string().uuid()).nullable(),
	allergies: z.array(z.string().uuid()).nullable(),
})
export type DogInfoStep2 = z.infer<typeof DogInfoStep2>

export const DogInfoSchema = DogInfoStep1.merge(DogInfoStep2)
	.merge(
		z.object({
			id: z.string().uuid().optional().nullable(),
			name: z.string().optional().nullable(),
			// createdAt: z.string().datetime(),
		}),
	)
	.transform((value) => {
		if (value.gender === GenderType.male) {
			switch (value.reproduction?.type) {
				case DogReproductionType.breastfeeding:
				case DogReproductionType.pregnant:
					return {
						...value,
						reproduction: null,
					}
			}
		}
		return value
	})

export type DogInfoSchema = z.infer<typeof DogInfoSchema>

export const DogInfoSerializer = {
	serialize: (dogInfo: DogInfoSchema) => JSON.stringify(DogInfoSchema.parse(dogInfo)),
	unserialize: (json: string) => DogInfoSchema.parse(JSON.parse(json)),
}
